define('businessServices/router/plugins/signupRouteAuthorizationPlugin',[
    'settings/navigationConfiguration',
    'businessServices/authentication/sessionAccountInfo',
    'common/converters/phoneNumberFormatter',
    'constants/signupSessionFlowConstants',
    'constants/signupSessionStatusConstants',
    'constants/signupNumberTypeSelectionConstants',
    'businessServices/signup/signupSessionStore',
    'common/storage/workSessionIdStorage'
], function () {
    const _navigationConfiguration = require('settings/navigationConfiguration');
    const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');
    const _signupSessionFlowConstants = require('constants/signupSessionFlowConstants');
    const _signupSessionStatusConstants = require('constants/signupSessionStatusConstants');
    const _signupNumberTypeSelectionConstants =require('constants/signupNumberTypeSelectionConstants');
    const _workSessionIdStorage = require('common/storage/workSessionIdStorage');

    const PhoneNumberFormatterConstructor = require('common/converters/phoneNumberFormatter');
    const _phoneNumberFormatter = new PhoneNumberFormatterConstructor();

    const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
    const PromiseFactoryConstructor = require('common/promises/promiseFactory');
    const _promiseFactory = new PromiseFactoryConstructor();
    const _signupSessionStore = new SignupSessionStoreConstructor();
    _signupSessionStore.init();

    const FLOW_A = _signupSessionFlowConstants.flowA;
    const FLOW_B = _signupSessionFlowConstants.flowB;
    const FLOW_C = _signupSessionFlowConstants.flowC;
    const FLOW_D = _signupSessionFlowConstants.flowD;
    const FLOW_AGENT = _signupSessionFlowConstants.flowAgent;

    const ROUTE__SIGNUP_EMAIL = _navigationConfiguration.routesById.signupEmail;
    const ROUTE__SIGNUP_PHONE_NUMBER_TYPE = _navigationConfiguration.routesById.signupPhoneNumberType;
    const ROUTE__SIGNUP_PHONE_NUMBER_LOCAL =  _navigationConfiguration.routesById.signupPhoneNumberLocal;
    const ROUTE__SIGNUP_PHONE_NUMBER_TOLL_FREE =  _navigationConfiguration.routesById.signupPhoneNumberTollfree;
    const ROUTE__SIGNUP_PHONE_NUMBER_PORT =  _navigationConfiguration.routesById.signupPhoneNumberPort;
    const ROUTE__SIGNUP_PHONE_NUMBER_PORT_BILLING =  _navigationConfiguration.routesById.signupPhoneNumberPortBilling;
    const ROUTE__SIGNUP_PHONE_NUMBER_PORT_AUTHORIZATION =  _navigationConfiguration.routesById.signupPhoneNumberPortAuthorization;
    const ROUTE__SIGNUP_PLANS = _navigationConfiguration.routesById.signupPlans;
    const ROUTE__SIGNUP_PROFILE =  _navigationConfiguration.routesById.signupProfile;
    const ROUTE__SIGNUP_SECURITY =  _navigationConfiguration.routesById.signupSecurity;
    const ROUTE__SIGNUP_PAYMENT_METHOD =  _navigationConfiguration.routesById.signupPaymentMethod;
    const ROUTE__SIGNUP_SCHEDULING =  _navigationConfiguration.routesById.signupScheduling;
    const ROUTE__SIGNUP_SUCCESS =  _navigationConfiguration.routesById.signupSuccess;

    const FLOW_A_ROUTE_START = ROUTE__SIGNUP_PLANS.url.replace(":flow", FLOW_A);
    const FLOW_B_ROUTE_START_LOCAL = ROUTE__SIGNUP_PHONE_NUMBER_LOCAL.url.replace(":flow", FLOW_B);
    const FLOW_B_ROUTE_START_TOLL_FREE = ROUTE__SIGNUP_PHONE_NUMBER_TOLL_FREE.url.replace(":flow", FLOW_B);
    const FLOW_B_ROUTE_START_PORT_NUMBER = ROUTE__SIGNUP_PHONE_NUMBER_PORT.url.replace(":flow", FLOW_B);
    const FLOW_C_ROUTE_START = ROUTE__SIGNUP_EMAIL.url.replace(":flow", FLOW_C);
    const FLOW_D_ROUTE_START = ROUTE__SIGNUP_PHONE_NUMBER_TYPE.url.replace(":flow", FLOW_D);
    const FLOW_AGENT_ROUTE_START = ROUTE__SIGNUP_PLANS.url.replace(":flow", FLOW_AGENT);

    const IS_EMAIL_COMPLETED = "isEmailCompleted";
    const IS_PHONE_NUMBER_COMPLETED = "isPhoneNumberCompleted";
    const IS_PROFILE_COMPLETED = "isProfileCompleted";
    const IS_PAYMENT_METHOD_COMPLETED ="isPaymentMethodCompleted";
    const IS_PLANS_COMPLETED ="isPlansCompleted";
    const IS_SECURITY_COMPLETED ="isSecurityCompleted";

    const STANDARD_PRIOR_ROUTES = {
        [ROUTE__SIGNUP_PLANS.routeId]: [],
        [ROUTE__SIGNUP_PROFILE.routeId]: [IS_PLANS_COMPLETED],
        [ROUTE__SIGNUP_SECURITY.routeId]: [IS_PLANS_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED],
        [ROUTE__SIGNUP_PHONE_NUMBER_TYPE.routeId]: [IS_PLANS_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_SECURITY_COMPLETED],
        [ROUTE__SIGNUP_PHONE_NUMBER_LOCAL.routeId]: [IS_PLANS_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_SECURITY_COMPLETED],
        [ROUTE__SIGNUP_PHONE_NUMBER_TOLL_FREE.routeId]: [IS_PLANS_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_SECURITY_COMPLETED],
        [ROUTE__SIGNUP_PHONE_NUMBER_PORT.routeId]: [IS_PLANS_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_SECURITY_COMPLETED],
        [ROUTE__SIGNUP_PHONE_NUMBER_PORT_BILLING.routeId]: [IS_PLANS_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_SECURITY_COMPLETED],
        [ROUTE__SIGNUP_PHONE_NUMBER_PORT_AUTHORIZATION.routeId]: [IS_PLANS_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_SECURITY_COMPLETED],
        [ROUTE__SIGNUP_PAYMENT_METHOD.routeId]: [IS_PLANS_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_SECURITY_COMPLETED, IS_PHONE_NUMBER_COMPLETED]
    };

    const ARE_PRIOR_ROUTES_COMPLETED = {
        [FLOW_A]: STANDARD_PRIOR_ROUTES,
        [FLOW_AGENT]: STANDARD_PRIOR_ROUTES,
        [FLOW_B]: {
            [ROUTE__SIGNUP_PHONE_NUMBER_TYPE.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_LOCAL.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_TOLL_FREE.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_PORT.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_PORT_BILLING.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_PORT_AUTHORIZATION.routeId]: [],
            [ROUTE__SIGNUP_EMAIL.routeId]:[IS_PHONE_NUMBER_COMPLETED],
            [ROUTE__SIGNUP_PROFILE.routeId]: [IS_PHONE_NUMBER_COMPLETED, IS_EMAIL_COMPLETED],
            [ROUTE__SIGNUP_PLANS.routeId]:[IS_PHONE_NUMBER_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED],
            [ROUTE__SIGNUP_SECURITY.routeId]:[IS_PHONE_NUMBER_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_PLANS_COMPLETED],
            [ROUTE__SIGNUP_PAYMENT_METHOD.routeId]: [IS_PHONE_NUMBER_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_PLANS_COMPLETED, IS_SECURITY_COMPLETED]
        },
        [FLOW_C]: {
            [ROUTE__SIGNUP_PHONE_NUMBER_TYPE.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_LOCAL.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_TOLL_FREE.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_PORT.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_PORT_BILLING.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_PORT_AUTHORIZATION.routeId]: [],
            [ROUTE__SIGNUP_EMAIL.routeId]:[],
            [ROUTE__SIGNUP_PROFILE.routeId]: [IS_EMAIL_COMPLETED],
            [ROUTE__SIGNUP_PLANS.routeId]:[IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED],
            [ROUTE__SIGNUP_SECURITY.routeId]:[IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_PLANS_COMPLETED],
            [ROUTE__SIGNUP_PAYMENT_METHOD.routeId]: [IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_PLANS_COMPLETED, IS_SECURITY_COMPLETED]
        },
        [FLOW_D]: {
            [ROUTE__SIGNUP_PHONE_NUMBER_TYPE.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_LOCAL.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_TOLL_FREE.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_PORT.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_PORT_BILLING.routeId]: [],
            [ROUTE__SIGNUP_PHONE_NUMBER_PORT_AUTHORIZATION.routeId]: [],
            [ROUTE__SIGNUP_EMAIL.routeId]:[IS_PHONE_NUMBER_COMPLETED],
            [ROUTE__SIGNUP_PROFILE.routeId]: [IS_PHONE_NUMBER_COMPLETED, IS_EMAIL_COMPLETED],
            [ROUTE__SIGNUP_PLANS.routeId]:[IS_PHONE_NUMBER_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED],
            [ROUTE__SIGNUP_SECURITY.routeId]: [IS_PHONE_NUMBER_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_PLANS_COMPLETED],
            [ROUTE__SIGNUP_PAYMENT_METHOD.routeId]: [IS_PHONE_NUMBER_COMPLETED, IS_EMAIL_COMPLETED, IS_PROFILE_COMPLETED, IS_PLANS_COMPLETED, IS_SECURITY_COMPLETED]
        }
    };

    const STANDARD_SUCCESS_PRIOR_ROUTES = {
        [ROUTE__SIGNUP_SUCCESS.routeId]: [
            IS_EMAIL_COMPLETED,
            IS_PROFILE_COMPLETED,
            IS_PLANS_COMPLETED,
            IS_SECURITY_COMPLETED,
            IS_PHONE_NUMBER_COMPLETED,
            IS_PAYMENT_METHOD_COMPLETED
        ]
    };

    const ARE_SIGNUP_SUCCESS_PRIOR_ROUTES_COMPLETED = {
        [FLOW_A]: STANDARD_SUCCESS_PRIOR_ROUTES,
        [FLOW_AGENT]: STANDARD_SUCCESS_PRIOR_ROUTES,
        [FLOW_B]: {
            [ROUTE__SIGNUP_SUCCESS.routeId]: [
                IS_PHONE_NUMBER_COMPLETED,
                IS_EMAIL_COMPLETED,
                IS_PROFILE_COMPLETED,
                IS_PLANS_COMPLETED,
                IS_SECURITY_COMPLETED,
                IS_PAYMENT_METHOD_COMPLETED
            ]
        },
        [FLOW_C]: {
            [ROUTE__SIGNUP_SUCCESS.routeId]: [
                IS_EMAIL_COMPLETED,
                IS_PROFILE_COMPLETED,
                IS_PLANS_COMPLETED,
                IS_SECURITY_COMPLETED,
                IS_PAYMENT_METHOD_COMPLETED
            ]
        },
        [FLOW_D]: {
            [ROUTE__SIGNUP_SUCCESS.routeId]: [
                IS_PHONE_NUMBER_COMPLETED,
                IS_EMAIL_COMPLETED,
                IS_PROFILE_COMPLETED,
                IS_PLANS_COMPLETED,
                IS_SECURITY_COMPLETED,
                IS_PAYMENT_METHOD_COMPLETED
            ]
        }
    };

    const SEARCH_TYPE_ENUMERATIONS = {
        any: "any",
        default: "default",
        repeat: "repeat",
        vanity: "vanity"
    };

    const routeToSignup = (routeId, routeInfo) => {
        switch (routeId) {
            case ROUTE__SIGNUP_EMAIL.routeId:
            case ROUTE__SIGNUP_PHONE_NUMBER_TYPE.routeId:
            case ROUTE__SIGNUP_PHONE_NUMBER_LOCAL.routeId:
            case ROUTE__SIGNUP_PHONE_NUMBER_TOLL_FREE.routeId:
            case ROUTE__SIGNUP_PHONE_NUMBER_PORT.routeId:
            case ROUTE__SIGNUP_PHONE_NUMBER_PORT_BILLING.routeId:
            case ROUTE__SIGNUP_PHONE_NUMBER_PORT_AUTHORIZATION.routeId:
            case ROUTE__SIGNUP_PLANS.routeId:
            case ROUTE__SIGNUP_PROFILE.routeId:
            case ROUTE__SIGNUP_PAYMENT_METHOD.routeId:
            case ROUTE__SIGNUP_SECURITY.routeId:
            case ROUTE__SIGNUP_SCHEDULING.routeId:
            case ROUTE__SIGNUP_SUCCESS.routeId:
                break;
            default:
                return true;
        }

        if (_sessionAccountInfo.isLoggedIn() !== false) {
            return _newRoute(_navigationConfiguration.homePageUrl);
        }

        return _promiseFactory.defer((promise) => {
            _signupSessionStore.get()
                .fail(promise.reject)
                .done((signupDocument) => {
                    const isFlowStart = _isFlowStartPage(routeInfo.fragment);
                    const isValidSignupSession = _isSignupSessionStatusValid(signupDocument.signupSessionStatus);
                    const localPromise = new PromiseFactoryConstructor();

                    const isTerminalSignupRoute = routeId === ROUTE__SIGNUP_SUCCESS.routeId ||
                        routeId === ROUTE__SIGNUP_SCHEDULING.routeId;

                    if (isValidSignupSession === false && isTerminalSignupRoute === false) {
                        localPromise.defer((localDeferredObject) => {
                            if (isFlowStart){
                                _signupSessionStore.generateNewSignup()
                                    .fail(localDeferredObject.reject)
                                    .done((newSignupDocument) => {
                                        signupDocument = newSignupDocument;
                                        localDeferredObject.resolve();
                                    });
                            } else {
                                localDeferredObject.resolve();
                            }
                        });
                    }

                    localPromise.wait()
                        .fail(promise.reject)
                        .done(() => {
                            if (routeInfo.params.length > 0) {
                                const flowId = routeInfo.params[0];
                                if (_isFlowIdValid(flowId)) {
                                    if (flowId === FLOW_AGENT && _isAgentSignup() === false) {
                                        promise.resolve(_routeToDefaultFlow(FLOW_A, routeInfo.queryString));
                                        return;
                                    }

                                    if (_areQueryParametersValid(flowId, routeInfo, signupDocument.reservedPhoneNumber)) {
                                        if (isTerminalSignupRoute)  {
                                            promise.resolve(_navigateToTerminalSignupRoute(flowId, routeInfo,  signupDocument));
                                        } else if (isValidSignupSession === false && isFlowStart === false) {
                                            promise.resolve(_routeWithoutValidSignupSession(flowId, routeInfo, signupDocument));
                                        } else {
                                            _navigateToValidSignupRoute(routeId, routeInfo, signupDocument)
                                                .fail(promise.reject)
                                                .done((result) => {
                                                    promise.resolve(result);
                                                });
                                        }
                                    } else {
                                        promise.resolve(_routeToDefaultFlow(FLOW_A));
                                    }
                                }
                            } else {
                                promise.resolve(_routeToDefaultFlow(signupDocument.flow, null, signupDocument.numberTypeSelection));
                            }
                        });
                });
        });
    };

    const _isSignupSessionStatusValid = (signupSessionStatus) => {
        switch (signupSessionStatus) {
            case _signupSessionStatusConstants.inProgress:
            case _signupSessionStatusConstants.initiated:
            case _signupSessionStatusConstants.validated:
            case _signupSessionStatusConstants.numberProvisioningFailed:
            case _signupSessionStatusConstants.numberProvisioningSucceeded:
            case _signupSessionStatusConstants.preAuthorizationFailed:
            case _signupSessionStatusConstants.preAuthorizationSucceeded:
                return true;
            default:
                return false;
        }
    };

    const _isAccountCreationStatus = (signupSessionStatus) => {
        switch (signupSessionStatus) {
            case _signupSessionStatusConstants.accountCreationPending:
            case _signupSessionStatusConstants.accountCreationInProgress:
            case _signupSessionStatusConstants.accountCreationCompleted:
            case _signupSessionStatusConstants.accountCreationFailedRetryQueued:
            case _signupSessionStatusConstants.accountCreationFailed:
                return true;
            default:
                return false;
        }
    };

    // A customer whose account is being or has been created belongs at sign-in. Anyone else on flow
    // A or Agent restarts at plans, where the guard creates their session, keeping the query string.
    const _routeWithoutValidSignupSession = (flowId, routeInfo, signupDocument) => {
        const isStandardFlow = flowId === FLOW_A || flowId === FLOW_AGENT;
        if (isStandardFlow === false || _isAccountCreationStatus(signupDocument.signupSessionStatus)) {
            return _newRoute(_navigationConfiguration.loginPageUrl);
        }

        return _routeToDefaultFlow(flowId, routeInfo.queryString);
    };

    const NUMBER_PICKER_ROUTE_IDS = [
        ROUTE__SIGNUP_PHONE_NUMBER_LOCAL.routeId,
        ROUTE__SIGNUP_PHONE_NUMBER_TOLL_FREE.routeId,
        ROUTE__SIGNUP_PHONE_NUMBER_PORT.routeId,
        ROUTE__SIGNUP_PHONE_NUMBER_PORT_BILLING.routeId,
        ROUTE__SIGNUP_PHONE_NUMBER_PORT_AUTHORIZATION.routeId
    ];

    const _isAgentSignup = () => {
        const workSessionId = _workSessionIdStorage.getWorkSessionId();
        return workSessionId !== null && workSessionId !== undefined;
    };

    // Agents always pick their own number; self-service, only telephony-only customers do. Everyone
    // else is assigned one at payment, so the number segment is not reachable for them.
    const _hasOnlyTelephonyPackage = (signupDocument) => {
        return !!(signupDocument.telephonyPackageId &&
            !signupDocument.liveReceptionistPackageId &&
            !signupDocument.webChatPackageId &&
            !signupDocument.outboundCallingPackageId);
    };

    const _isRouteReachable = (routeId, flowId, signupDocument) => {
        if (flowId !== FLOW_A && flowId !== FLOW_AGENT) {
            return true;
        }

        const isNumberRoute = routeId === ROUTE__SIGNUP_PHONE_NUMBER_TYPE.routeId ||
            NUMBER_PICKER_ROUTE_IDS.indexOf(routeId) !== -1;

        if (isNumberRoute) {
            return _isAgentSignup() || _hasOnlyTelephonyPackage(signupDocument);
        }

        return true;
    };

    const _isFlowIdValid = (flowId) => {
        switch (flowId) {
            case FLOW_A:
            case FLOW_AGENT:
            case FLOW_B:
            case FLOW_C:
            case FLOW_D:
                return true;
            default:
                return false;
        }
    };

    const _isFlowStartPage = (url) => {
        switch (url) {
            case FLOW_A_ROUTE_START:
            case FLOW_AGENT_ROUTE_START:
            case FLOW_B_ROUTE_START_LOCAL:
            case FLOW_B_ROUTE_START_TOLL_FREE:
            case FLOW_B_ROUTE_START_PORT_NUMBER:
            case FLOW_C_ROUTE_START:
            case FLOW_D_ROUTE_START:
                return true;
            default:
                return false;
        }
    };

    const _areFlowCQueryParametersValid = (params) => {
        if (params === null) {
            return false;
        }

        switch (params.searchType) {
            case SEARCH_TYPE_ENUMERATIONS.any:
                return params.hasOwnProperty("phoneNumber") &&
                    params.hasOwnProperty("region") &&
                    params.hasOwnProperty("city");
            case SEARCH_TYPE_ENUMERATIONS.default:
                return params.hasOwnProperty("phoneNumber") &&
                    params.hasOwnProperty("region") &&
                    params.hasOwnProperty("city");
            case SEARCH_TYPE_ENUMERATIONS.repeat:
                return params.hasOwnProperty("phoneNumber") &&
                    params.hasOwnProperty("region");
            case SEARCH_TYPE_ENUMERATIONS.vanity:
                return params.hasOwnProperty("phoneNumber") &&
                    params.hasOwnProperty("vanityString");
            default:
                return false;
        }

    };

    const _areQueryParametersValid = (flowId, routeInfo, reservedPhoneNumber) => {
        let url = routeInfo.fragment;
        let params = routeInfo.queryParams;

        switch (flowId) {
            case FLOW_A:
            case FLOW_AGENT:
            case FLOW_D:
                return true;
            case FLOW_B:
                if (url !== FLOW_B_ROUTE_START_PORT_NUMBER) {
                    return true;
                }

                if (params === null) {
                    return true;
                }

                return params.hasOwnProperty("phoneNumber") &&
                    params.hasOwnProperty("carrier") &&
                    params.hasOwnProperty("country");

            case FLOW_C:
                if (url !== FLOW_C_ROUTE_START) {
                    return true;
                }
                if (reservedPhoneNumber) {
                    return true;
                }

                return _areFlowCQueryParametersValid(params);

            default:
                return false;
        }
    };

    const _navigateToValidSignupRoute = (routeId, routeInfo, signupDocument) => {
        return _promiseFactory.defer((promise) => {
            const flowId = routeInfo.params[0];
            if (flowId === signupDocument.flow || signupDocument.flow === null) {
                const localPromise = new PromiseFactoryConstructor();

                if (signupDocument.flow === null) {
                    localPromise.defer((deferredLocalPromise) => {
                        _signupSessionStore.saveFlow(flowId)
                            .fail(deferredLocalPromise.reject)
                            .done(deferredLocalPromise.resolve);
                    });
                }

                localPromise.wait()
                    .fail(promise.reject)
                    .done(() => {
                        if (routeInfo.queryParams &&
                            signupDocument.reservedPhoneNumber &&
                            signupDocument.reservedPhoneNumber !== _phoneNumberFormatter.toEOneSixFour(routeInfo.queryParams.phoneNumber)
                        ) {
                            _signupSessionStore.generateNewSignup()
                                .fail(promise.reject)
                                .done(() => {
                                    _signupSessionStore.saveFlow(flowId)
                                        .fail(promise.reject)
                                        .done(() => {
                                            promise.resolve(true);
                                        });
                                });
                        } else {
                            const arePriorRoutesCompletedList = ARE_PRIOR_ROUTES_COMPLETED[flowId][routeId];
                            if (arePriorRoutesCompletedList === undefined) {
                                promise.resolve(_routeToDefaultFlow(flowId, routeInfo.queryString));
                                return;
                            }

                            const arePriorRoutesCompleted = arePriorRoutesCompletedList.every((isPriorRouteCompleted) => {
                                return signupDocument[isPriorRouteCompleted] === true;
                            });

                            if (arePriorRoutesCompleted) {
                                if (_isRouteReachable(routeId, flowId, signupDocument) === false) {
                                    promise.resolve(_routeToDefaultFlow(flowId, routeInfo.queryString));
                                    return;
                                }
                                promise.resolve(true);
                            } else {
                                promise.resolve(_routeToDefaultFlow(flowId, routeInfo.queryString));
                            }
                        }
                    });
            } else {
                if (_isFlowStartPage(routeInfo.fragment)) {
                    _signupSessionStore.generateNewSignup()
                        .fail(promise.reject)
                        .done(() => {
                            _signupSessionStore.saveFlow(flowId)
                                .fail(promise.reject)
                                .done(() => {
                                    promise.resolve(true);
                                });
                        });
                } else {
                    promise.resolve(_routeToDefaultFlow(signupDocument.flow, routeInfo.queryString));
                }
            }
        });
    };

    const _navigateToTerminalSignupRoute = (flowId, routeInfo, signupSession) => {
        const arePriorRoutesCompletedList = ARE_SIGNUP_SUCCESS_PRIOR_ROUTES_COMPLETED[flowId][ROUTE__SIGNUP_SUCCESS.routeId];
        const arePriorRoutesCompleted = arePriorRoutesCompletedList.every((isPriorRouteCompleted) => {
            return signupSession[isPriorRouteCompleted] === true;
        });

        if (arePriorRoutesCompleted) {
            return true;
        }

        return _routeToDefaultFlow(flowId, routeInfo.queryString);
    };


    const _routeToDefaultFlow = (flowId, queryString=null, numberTypeSelection=null) => {
        let flowRouteStart = null;
        switch (flowId) {
            case FLOW_A:
                flowRouteStart = FLOW_A_ROUTE_START;
                break;
            case FLOW_AGENT:
                flowRouteStart = FLOW_AGENT_ROUTE_START;
                break;
            case FLOW_B:
                switch (numberTypeSelection) {
                    case _signupNumberTypeSelectionConstants.local:
                        flowRouteStart = FLOW_B_ROUTE_START_LOCAL;
                        break;
                    case _signupNumberTypeSelectionConstants.tollFree:
                        flowRouteStart = FLOW_B_ROUTE_START_TOLL_FREE;
                        break;
                    case _signupNumberTypeSelectionConstants.port:
                        flowRouteStart = FLOW_B_ROUTE_START_PORT_NUMBER;
                        break;
                    default:
                        flowRouteStart = FLOW_B_ROUTE_START_LOCAL;
                }
                break;
            case FLOW_C:
                flowRouteStart = FLOW_C_ROUTE_START;
                break;
            case FLOW_D:
                flowRouteStart = FLOW_D_ROUTE_START;
                break;
            default:
                flowRouteStart = FLOW_A_ROUTE_START;
        }

        if (queryString !== null) {
            flowRouteStart = flowRouteStart + "?" + queryString;
        }

        return _newRoute(flowRouteStart);
    };

    const _newRoute = (routeUrl) => {
        return { routeUrl: routeUrl};
    };

    return {
        guardRoute: routeToSignup
    };
});
